import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import DateRangeSelector from "./DateRangeSelector";
import "./draftbanner.css";
import { getBranchesAccountNo } from "../services/userservice";
import Loader from '../images/whiteloader.svg';

const FilterPanel = ({userInfo,filterName, accounts, subaccounts, subAccountsLocal, 
  setSubAccountsLocal, setLocations, locations, filters, setFilters, getMultipleSubAccountLocations, destinations, onSearch, loading}) => {
    const [selected, setSelected] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState([]);
    const [selectedSubAccount, setSelectedSubAccount] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedDest, setSelectedDest] = useState([]);
    const [selectedOrigin, setSelectedOrigin] = useState([]);
    const [branches, setBranches] = useState([]);
    


    useEffect(() => {
      setSelectedAccount(filters.accounts.map(i => ({label: i, value: i})))
      getBranchesAccountNo(accounts[0])
                .then(x => {
                    if (x && x.length > 0)
                        setBranches(x);
                })
    }, [])


    const AccountsOptions = accounts.map(i => ({label: i, value: i}));
    const SubAccountsOptions = subAccountsLocal.map(i => ({label: i.name, value: i.id}));
    const locationOptions = locations.map(i => ({label: i.text, value: i.value}));
    const destinationsOption = destinations.map(i => ({label: i.text, value: i.value}));
    const originOption = branches.map(i => ({label: i.text, value: i.value}));

    const options = [
      { label: "Grapes 🍇", value: "grapes" },
      { label: "Mango 🥭", value: "mango" },
      { label: "Strawberry 🍓", value: "strawberry", disabled: true },
    ];

  return (
    <div className="filter-panel bg-white shadow-sm filter-header">
      <h5 className="fw-bold filter-heading ">{filterName} Filters</h5>

      <div className="row g-3">
        <div className="col-md-4 col-md-4-4">
          <label className="form-label">Account</label>
          <MultiSelect
            options={AccountsOptions}
            value={selectedAccount}
            onChange={async w => {
              const d = { ...filters, accounts: w.map(s => s.label) };
              if (w && w.length > 0) {

                const subAccs = subaccounts.filter(e => w.map(s => s.label).includes(e.accountNo));
    
                setSubAccountsLocal(subAccs);

                getBranchesAccountNo(w.map(s => s.label)[0])
                .then(x => {
                    if (x && x.length > 0)
                        setBranches(x);
                })
                

               
    
                const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
                //d.subAccountId =  [subAccs[0].id];
    
                if (locs.length > 0) {
                    //d.locationID = [+locs[0].value]
                    setLocations(locs);
                } else {
                    setLocations([]);
                }
              } else {
                  setLocations([]);
                  setSubAccountsLocal([]);
              }
              setFilters(d);
              setSelectedAccount(w);
            }}
            labelledBy="Select"
          />
        </div>

        <div className="col-md-4 col-md-4-4">
          <label className="form-label">Sub-Account</label>
          <MultiSelect
            options={SubAccountsOptions}
            value={selectedSubAccount}
            onChange={async (e) => {
                // const selectedOptions = Array.from(e.target.selectedOptions);
                // console.log(selectedOptions);
                // const accnos = selectedOptions
                //     .map(option => option.getAttribute('data-accno'))
                //     .filter(acc => acc && acc.trim() !== '');


                                                
                // console.log(accnos);
                
                // const uniqueAccnos = Array.from(
                //     new Map(accnos.map(acc => [acc.toLowerCase(), acc])).values()
                // );

                // console.log(uniqueAccnos);
                
                // // Get subAccount IDs, remove empty, convert to int, and make unique
                // const val = Array.from(new Set(
                //     selectedOptions
                //         .map(option => option.value)
                //         .filter(v => v && !isNaN(v))
                //         .map(v => parseInt(v))
                // ));

                
                const val = e.map(s => s.value);
                
                const uniqueAccnos = [...new Set(
                  subAccountsLocal.filter(item => val.includes(item.id))
                      .map(item => item.accountNo)
                )]
                .map(acc => `${acc}`);

                const d = { ...filters, subAccountId: val, accounts: uniqueAccnos };
                if (val) {
                    //d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                    const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: val})
                    if (locs && locs.length > 0) {
                        
                        //d.locationID = [+locs[0].value]
                        setLocations(locs);
                    } else {
                        setLocations([]);
                    }
                } else {
                    setLocations([]);
                    //d.isCod = null;
                }
                setSelectedSubAccount(e);
                setSelectedLocation([]);
                setFilters({...d});
            }}

            //onChange={setSelected}
            labelledBy="Select"
          />
        </div>

        <div className="col-md-4 col-md-4-4">
          <label className="form-label">Location</label>
          <MultiSelect
            options={locationOptions}
            value={selectedLocation}

            onChange={(e) => {
              const val = e.map(s => s.value);
              setFilters({ ...filters, locationID: val });
              setSelectedLocation(e)
            }}
            labelledBy="Select"
          />
        </div>

        <div className="col-md-4 col-md-4-4">
          <DateRangeSelector filters={filters} setFilters={setFilters} />
        </div>

        <div className="col-md-4 col-md-4-4">
          <label className="form-label">Origin City</label>
          <MultiSelect
            options={originOption}
            value={selectedOrigin}
            onChange={(e) => {
              const val = e.map(s => s.value);
              setFilters({...filters, originIds: val})
              setSelectedOrigin(e)
            }}
            labelledBy="Select"
          />
        </div>

        <div className="col-md-4 col-md-4-4">
          <label className="form-label">Destination (Service Cities)</label>
          <MultiSelect
            options={destinationsOption}
            value={selectedDest}
            onChange={(e) => {
              const val = e.map(s => s.value);
              setFilters({...filters, destIds: val})
              setSelectedDest(e)
            }}
          />
        </div>

        <div className="filter-search-button">
            <button type="button" className="btn btn-primary" disabled={loading} style={{ display : 'flex', placeSelf: 'center' }} onClick={onSearch}>
                {loading ? <img src={Loader} height="30" /> : 'Search'}
            </button>
        </div>

        {/* Future scope: Tabs for shipment/finance/graphs-specific filters */}
      </div>
    </div>
  );
};

export default FilterPanel;
